import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=31e3ba41&scoped=true"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"
import style0 from "./error-page.vue?vue&type=style&index=0&id=31e3ba41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3ba41",
  null
  
)

export default component.exports